// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Chat Sidebar ─────────────────────────────────────────── */
.chat-sidebar { display: flex; flex-direction: column; height: 100%; overflow: hidden; }

.chat-sidebar-section { margin-bottom: 4px; }

.chat-sidebar-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: var(--text-muted);
  text-transform: uppercase;
}

.chat-sidebar-group-header .btn-icon { opacity: 0.6; }
.chat-sidebar-group-header .btn-icon:hover { opacity: 1; }

.chat-sidebar-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 10px 5px 14px;
  font-size: 13px;
  color: var(--text-secondary);
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  gap: 6px;
  border-radius: 0;
  transition: background 0.1s, color 0.1s;
}
.chat-sidebar-item:hover  { background: var(--bg-hover); color: var(--text-primary); }
.chat-sidebar-item.active { background: var(--bg-active); color: var(--text-primary); }
.chat-sidebar-item.unread { color: var(--text-primary); font-weight: 500; }

.chat-sidebar-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.chat-unread-badge {
  background: var(--red);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 10px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  flex-shrink: 0;
}

.chat-type-icon { flex-shrink: 0; color: var(--text-muted); }

.chat-sidebar-row {
  display: flex;
  align-items: center;
  position: relative;
}
.chat-sidebar-row .chat-sidebar-item { flex: 1; }

.chat-sidebar-action {
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-right: 4px;
  color: var(--text-muted);
  background: none;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.chat-sidebar-action:hover { color: var(--text-primary); background: var(--bg-active); }
.chat-sidebar-row:hover .chat-sidebar-action { display: flex; }

/* Always show on touch screens */
@media (hover: none) {
  .chat-sidebar-row .chat-sidebar-action { display: flex; }
}

/* ── Chat Window ──────────────────────────────────────────── */
.chat-window {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.chat-window-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-secondary);
  flex-shrink: 0;
}

.chat-window-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1;
}

.chat-window-subtitle {
  font-size: 11px;
  color: var(--text-muted);
}

.chat-offline-banner {
  flex-shrink: 0;
  padding: 4px 12px;
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border);
  text-align: center;
}

.chat-messages {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 0;
}

.chat-load-more {
  display: block;
  margin: 6px auto;
  padding: 3px 12px;
  font-size: 12px;
  color: var(--text-muted);
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 4px;
  cursor: pointer;
}
.chat-load-more:hover { color: var(--text-primary); }

.chat-message-header {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.chat-sender {
  font-size: 13px;
  font-weight: 600;
  cursor: default;
}

/* Role-based sender colors matching Users page */
.chat-sender.role-admin    { color: var(--red); }
.chat-sender.role-engineer { color: var(--accent-light); }
.chat-sender.role-foreman  { color: #4ec9b0; }
.chat-sender.role-standard { color: var(--text-secondary); }
.chat-sender.role-client   { color: var(--yellow); }
.chat-sender.role-other    { color: var(--text-muted); }

.chat-timestamp {
  font-size: 11px;
  color: var(--text-muted);
}


.chat-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.chat-img {
  max-width: 320px;
  max-height: 240px;
  border-radius: 4px;
  border: 1px solid var(--border);
  cursor: pointer;
  display: block;
}
.chat-img:hover { opacity: 0.9; }

.chat-img-preview {
  position: relative;
  display: inline-block;
}

.chat-img-preview img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid var(--border);
  display: block;
}

.chat-img-preview img.uploading { opacity: 0.5; }

.chat-img-remove {
  position: absolute;
  top: -4px; right: -4px;
  width: 16px; height: 16px;
  border-radius: 50%;
  background: var(--red);
  color: #fff;
  font-size: 10px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
}

.chat-attach-btn {
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--text-muted);
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 4px;
  cursor: pointer;
}
.chat-attach-btn:hover { color: var(--text-primary); }

/* Mention highlighting */
.chat-mention-all {
  color: var(--yellow);
  background: rgba(220, 220, 170, 0.12);
  border-radius: 3px;
  padding: 0 2px;
  font-weight: 600;
}

.chat-mention-user {
  color: var(--accent-light);
  background: rgba(86, 156, 214, 0.12);
  border-radius: 3px;
  padding: 0 2px;
  font-weight: 500;
}

/* Smart links */
.chat-link {
  color: #4ec9b0;
  text-decoration: none;
  cursor: pointer;
  border-radius: 3px;
  padding: 0 1px;
}
.chat-link:hover { text-decoration: underline; background: rgba(78,201,176,0.1); }

/* ── Chat Input ───────────────────────────────────────────── */
.chat-input-area {
  border-top: 1px solid var(--border);
  padding: 8px 12px;
  flex-shrink: 0;
  position: relative;
}

.chat-input-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.chat-input {
  flex: 1;
  min-height: 36px;
  max-height: 120px;
  resize: none;
  overflow-y: auto;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 4px;
  color: var(--text-primary);
  font-size: 13px;
  font-family: inherit;
  padding: 8px 10px;
  line-height: 1.4;
  outline: none;
}
.chat-input:focus { border-color: var(--accent-light); }

.chat-send-btn {
  height: 36px;
  padding: 0 14px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  flex-shrink: 0;
}
.chat-send-btn:hover   { background: var(--accent-hover); }
.chat-send-btn:disabled { opacity: 0.5; cursor: default; }

/* Mention autocomplete dropdown */
.chat-mention-dropdown {
  position: absolute;
  bottom: calc(100% + 4px);
  left: 12px;
  right: 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 100;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.3);
}

.chat-mention-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
}
.chat-mention-option:hover,
.chat-mention-option.selected { background: var(--bg-active); color: var(--text-primary); }

.chat-mention-option .role-dot {
  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
}
.role-dot-admin    { background: var(--red); }
.role-dot-engineer { background: var(--accent-light); }
.role-dot-foreman  { background: #4ec9b0; }
.role-dot-standard { background: var(--text-muted); }
.role-dot-client   { background: var(--yellow); }
.role-dot-other    { background: var(--text-muted); opacity: 0.5; }

/* ── Create Group Modal ───────────────────────────────────── */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 20px;
  width: 360px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modal h3 { font-size: 14px; font-weight: 600; color: var(--text-primary); margin: 0; }

.modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 4px; }

.member-list {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--bg-primary);
}

.member-list-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
}
.member-list-item:hover { background: var(--bg-hover); color: var(--text-primary); }
.member-list-item input[type=checkbox] { accent-color: var(--accent-light); }

/* ── Inline message layout ────────────────────────────────── */
.chat-message {
  display: flex;
  align-items: flex-start;
  padding: 2px 16px;
  gap: 0;
  position: relative;
  min-height: 22px;
}
.chat-message:hover { background: var(--bg-hover); }
.chat-message-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  white-space: nowrap;
  padding-right: 10px;
  padding-top: 2px;
  min-width: 0;
}
.chat-message-body {
  flex: 1;
  min-width: 0;
  padding-top: 1px;
}
.chat-content {
  font-size: 13px;
  color: var(--text-primary);
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-wrap;
  display: inline;
}
.chat-msg-actions {
  display: flex;
  flex-shrink: 0;
  opacity: 0;
  gap: 2px;
  margin-top: 1px;
  transition: opacity 0.1s;
}
.chat-message:hover .chat-msg-actions { opacity: 1; }

.chat-delete-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  background: none;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  transition: color 0.1s;
}
.chat-delete-btn:hover { color: var(--red); background: var(--bg-tertiary); }

.chat-edited {
  font-size: 10px;
  color: var(--text-muted);
  font-style: italic;
}

.chat-edit-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 2px;
}
.chat-edit-input {
  width: 100%;
  min-height: 60px;
  max-height: 200px;
  resize: vertical;
  background: var(--bg-input);
  border: 1px solid var(--accent-light);
  border-radius: 4px;
  color: var(--text-primary);
  font-size: 13px;
  font-family: inherit;
  padding: 6px 8px;
  line-height: 1.4;
  white-space: pre-wrap;
  outline: none;
}
.chat-edit-actions {
  display: flex;
  gap: 4px;
}

/* Always visible on touch screens */
@media (hover: none) {
  .chat-message .chat-msg-actions { opacity: 0.35; }
}

/* ── Member tooltip ───────────────────────────────────────── */
.chat-members-hover {
  position: relative;
  cursor: default;
  display: inline-block;
}
.chat-members-tooltip {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 6px 0;
  min-width: 130px;
  z-index: 50;
  box-shadow: 0 4px 12px rgba(0,0,0,0.4);
}
.chat-members-tooltip-item {
  padding: 4px 12px;
  font-size: 12px;
  white-space: nowrap;
}

/* ── Online status dot ────────────────────────────────────── */
.online-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--text-muted);
  flex-shrink: 0;
}
.online-dot.online { background: #4ec9b0; }

/* ── Typing indicator ─────────────────────────────────────── */
.chat-typing {
  padding: 3px 16px 3px;
  font-size: 11px;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.chat-typing-dots {
  display: flex;
  gap: 3px;
  align-items: center;
}
.chat-typing-dots span {
  width: 5px; height: 5px;
  background: var(--text-muted);
  border-radius: 50%;
  animation: typing-bounce 1.2s infinite;
}
.chat-typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.chat-typing-dots span:nth-child(3) { animation-delay: 0.4s; }
@keyframes typing-bounce {
  0%, 60%, 100% { transform: translateY(0); }
  30%            { transform: translateY(-4px); }
}

/* ── Message search bar ───────────────────────────────────── */
.chat-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-secondary);
  flex-shrink: 0;
}
.chat-search-input {
  flex: 1;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 3px;
  color: var(--text-primary);
  font-size: 12px;
  padding: 3px 7px;
  outline: none;
}
.chat-search-input:focus { border-color: var(--accent-light); }
.chat-search-count { font-size: 11px; color: var(--text-muted); white-space: nowrap; }

/* ── Mobile chat adjustments ─────────────────────────────── */
@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .chat-input { font-size: 16px; min-height: 44px; }
  .chat-send-btn { height: 44px; padding: 0 18px; font-size: 15px; }
  .chat-attach-btn { width: 44px; height: 44px; }
  .chat-sidebar-item { padding: 10px 10px 10px 14px; font-size: 14px; min-height: 44px; }
  .chat-img { max-width: 100%; }
  /* Push input area above the fixed bottom activity bar (56px) */
  .chat-input-area { padding-bottom: calc(8px + 56px); }
}

/* ── Lightbox ─────────────────────────────────────────────── */
.lightbox-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.85);
  z-index: 300;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}
.lightbox-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 4px;
  cursor: default;
  box-shadow: 0 8px 40px rgba(0,0,0,0.6);
}
.lightbox-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.1);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;
}
.lightbox-close:hover { background: rgba(255,255,255,0.2); }

/* ── File attachments in messages ─────────────────────────── */
.chat-file-attach {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 12px;
  color: var(--accent-light);
  text-decoration: none;
  cursor: pointer;
  margin-top: 4px;
}
.chat-file-attach:hover { background: var(--bg-active); text-decoration: underline; }

/* ── Pending file chips in input ──────────────────────────── */
.chat-pending-files {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-bottom: 6px;
}
.chat-file-pending {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 12px;
  color: var(--text-secondary);
  position: relative;
}
.chat-file-pending.uploading { opacity: 0.5; }
.chat-file-pending-name { max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* ── Activity badge (used in ActivityBar) ─────────────────── */
.activity-badge {
  position: absolute;
  top: 6px; right: 6px;
  background: var(--red);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  border-radius: 10px;
  min-width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/Chat.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,gBAAgB,EAAE;;AAEvF,wBAAwB,kBAAkB,EAAE;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,uCAAuC,YAAY,EAAE;AACrD,6CAA6C,UAAU,EAAE;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,uCAAuC;AACzC;AACA,4BAA4B,2BAA2B,EAAE,0BAA0B,EAAE;AACrF,4BAA4B,4BAA4B,EAAE,0BAA0B,EAAE;AACtF,4BAA4B,0BAA0B,EAAE,gBAAgB,EAAE;;AAE1E,qBAAqB,OAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAE9F;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA,kBAAkB,cAAc,EAAE,wBAAwB,EAAE;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA,uCAAuC,OAAO,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA,6BAA6B,0BAA0B,EAAE,4BAA4B,EAAE;AACvF,+CAA+C,aAAa,EAAE;;AAE9D,iCAAiC;AACjC;EACE,yCAAyC,aAAa,EAAE;AAC1D;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,OAAO;AACT;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;AACA,wBAAwB,0BAA0B,EAAE;;AAEpD;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iDAAiD;AACjD,6BAA6B,iBAAiB,EAAE;AAChD,6BAA6B,0BAA0B,EAAE;AACzD,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,4BAA4B,EAAE;AAC3D,6BAA6B,oBAAoB,EAAE;AACnD,6BAA6B,wBAAwB,EAAE;;AAEvD;EACE,eAAe;EACf,wBAAwB;AAC1B;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;AACA,kBAAkB,YAAY,EAAE;;AAEhC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,kCAAkC,YAAY,EAAE;;AAEhD;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;AACA,yBAAyB,0BAA0B,EAAE;;AAErD,yBAAyB;AACzB;EACE,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA,mBAAmB,0BAA0B,EAAE,gCAAgC,EAAE;;AAEjF,gEAAgE;AAChE;EACE,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;AACA,oBAAoB,iCAAiC,EAAE;;AAEvD;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,yBAAyB,+BAA+B,EAAE;AAC1D,0BAA0B,YAAY,EAAE,eAAe,EAAE;;AAEzD,kCAAkC;AAClC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA;gCACgC,4BAA4B,EAAE,0BAA0B,EAAE;;AAE1F;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc;AAC7D;AACA,qBAAqB,sBAAsB,EAAE;AAC7C,qBAAqB,+BAA+B,EAAE;AACtD,qBAAqB,mBAAmB,EAAE;AAC1C,qBAAqB,6BAA6B,EAAE;AACpD,qBAAqB,yBAAyB,EAAE;AAChD,qBAAqB,6BAA6B,EAAE,YAAY,EAAE;;AAElE,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,YAAY,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;;AAEtF,iBAAiB,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAEtF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA,0BAA0B,2BAA2B,EAAE,0BAA0B,EAAE;AACnF,yCAAyC,iCAAiC,EAAE;;AAE5E,gEAAgE;AAChE;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;AAClB;AACA,sBAAsB,2BAA2B,EAAE;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;AACA,wCAAwC,UAAU,EAAE;;AAEpD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA,yBAAyB,iBAAiB,EAAE,8BAA8B,EAAE;;AAE5E;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,oCAAoC;AACpC;EACE,kCAAkC,aAAa,EAAE;AACnD;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C,gEAAgE;AAChE;EACE,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,UAAU,EAAE,WAAW;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;AACxC;AACA,sCAAsC,qBAAqB,EAAE;AAC7D,sCAAsC,qBAAqB,EAAE;AAC7D;EACE,gBAAgB,wBAAwB,EAAE;EAC1C,iBAAiB,2BAA2B,EAAE;AAChD;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,OAAO;EACP,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA,2BAA2B,iCAAiC,EAAE;AAC9D,qBAAqB,eAAe,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;;AAErF,+DAA+D;AAC/D;EACE,cAAc,eAAe,EAAE,gBAAgB,EAAE;EACjD,iBAAiB,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE;EACjE,mBAAmB,WAAW,EAAE,YAAY,EAAE;EAC9C,qBAAqB,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE;EACtF,YAAY,eAAe,EAAE;EAC7B,+DAA+D;EAC/D,mBAAmB,gCAAgC,EAAE;AACvD;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;AACA,wBAAwB,iCAAiC,EAAE;;AAE3D,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;AACA,0BAA0B,4BAA4B,EAAE,0BAA0B,EAAE;;AAEpF,gEAAgE;AAChE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;AACA,+BAA+B,YAAY,EAAE;AAC7C,0BAA0B,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAE5G,gEAAgE;AAChE;EACE,kBAAkB;EAClB,QAAQ,EAAE,UAAU;EACpB,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB","sourcesContent":["/* ── Chat Sidebar ─────────────────────────────────────────── */\n.chat-sidebar { display: flex; flex-direction: column; height: 100%; overflow: hidden; }\n\n.chat-sidebar-section { margin-bottom: 4px; }\n\n.chat-sidebar-group-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 10px 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n  text-transform: uppercase;\n}\n\n.chat-sidebar-group-header .btn-icon { opacity: 0.6; }\n.chat-sidebar-group-header .btn-icon:hover { opacity: 1; }\n\n.chat-sidebar-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 5px 10px 5px 14px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  gap: 6px;\n  border-radius: 0;\n  transition: background 0.1s, color 0.1s;\n}\n.chat-sidebar-item:hover  { background: var(--bg-hover); color: var(--text-primary); }\n.chat-sidebar-item.active { background: var(--bg-active); color: var(--text-primary); }\n.chat-sidebar-item.unread { color: var(--text-primary); font-weight: 500; }\n\n.chat-sidebar-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n.chat-unread-badge {\n  background: var(--red);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 10px;\n  min-width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  flex-shrink: 0;\n}\n\n.chat-type-icon { flex-shrink: 0; color: var(--text-muted); }\n\n.chat-sidebar-row {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.chat-sidebar-row .chat-sidebar-item { flex: 1; }\n\n.chat-sidebar-action {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  margin-right: 4px;\n  color: var(--text-muted);\n  background: none;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.chat-sidebar-action:hover { color: var(--text-primary); background: var(--bg-active); }\n.chat-sidebar-row:hover .chat-sidebar-action { display: flex; }\n\n/* Always show on touch screens */\n@media (hover: none) {\n  .chat-sidebar-row .chat-sidebar-action { display: flex; }\n}\n\n/* ── Chat Window ──────────────────────────────────────────── */\n.chat-window {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.chat-window-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-secondary);\n  flex-shrink: 0;\n}\n\n.chat-window-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  flex: 1;\n}\n\n.chat-window-subtitle {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.chat-offline-banner {\n  flex-shrink: 0;\n  padding: 4px 12px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border);\n  text-align: center;\n}\n\n.chat-messages {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.chat-load-more {\n  display: block;\n  margin: 6px auto;\n  padding: 3px 12px;\n  font-size: 12px;\n  color: var(--text-muted);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  cursor: pointer;\n}\n.chat-load-more:hover { color: var(--text-primary); }\n\n.chat-message-header {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.chat-sender {\n  font-size: 13px;\n  font-weight: 600;\n  cursor: default;\n}\n\n/* Role-based sender colors matching Users page */\n.chat-sender.role-admin    { color: var(--red); }\n.chat-sender.role-engineer { color: var(--accent-light); }\n.chat-sender.role-foreman  { color: #4ec9b0; }\n.chat-sender.role-standard { color: var(--text-secondary); }\n.chat-sender.role-client   { color: var(--yellow); }\n.chat-sender.role-other    { color: var(--text-muted); }\n\n.chat-timestamp {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n\n.chat-attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.chat-img {\n  max-width: 320px;\n  max-height: 240px;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  cursor: pointer;\n  display: block;\n}\n.chat-img:hover { opacity: 0.9; }\n\n.chat-img-preview {\n  position: relative;\n  display: inline-block;\n}\n\n.chat-img-preview img {\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  display: block;\n}\n\n.chat-img-preview img.uploading { opacity: 0.5; }\n\n.chat-img-remove {\n  position: absolute;\n  top: -4px; right: -4px;\n  width: 16px; height: 16px;\n  border-radius: 50%;\n  background: var(--red);\n  color: #fff;\n  font-size: 10px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  line-height: 1;\n}\n\n.chat-attach-btn {\n  height: 36px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--text-muted);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  cursor: pointer;\n}\n.chat-attach-btn:hover { color: var(--text-primary); }\n\n/* Mention highlighting */\n.chat-mention-all {\n  color: var(--yellow);\n  background: rgba(220, 220, 170, 0.12);\n  border-radius: 3px;\n  padding: 0 2px;\n  font-weight: 600;\n}\n\n.chat-mention-user {\n  color: var(--accent-light);\n  background: rgba(86, 156, 214, 0.12);\n  border-radius: 3px;\n  padding: 0 2px;\n  font-weight: 500;\n}\n\n/* Smart links */\n.chat-link {\n  color: #4ec9b0;\n  text-decoration: none;\n  cursor: pointer;\n  border-radius: 3px;\n  padding: 0 1px;\n}\n.chat-link:hover { text-decoration: underline; background: rgba(78,201,176,0.1); }\n\n/* ── Chat Input ───────────────────────────────────────────── */\n.chat-input-area {\n  border-top: 1px solid var(--border);\n  padding: 8px 12px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.chat-input-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.chat-input {\n  flex: 1;\n  min-height: 36px;\n  max-height: 120px;\n  resize: none;\n  overflow-y: auto;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  color: var(--text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  padding: 8px 10px;\n  line-height: 1.4;\n  outline: none;\n}\n.chat-input:focus { border-color: var(--accent-light); }\n\n.chat-send-btn {\n  height: 36px;\n  padding: 0 14px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.chat-send-btn:hover   { background: var(--accent-hover); }\n.chat-send-btn:disabled { opacity: 0.5; cursor: default; }\n\n/* Mention autocomplete dropdown */\n.chat-mention-dropdown {\n  position: absolute;\n  bottom: calc(100% + 4px);\n  left: 12px;\n  right: 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 100;\n  box-shadow: 0 -2px 8px rgba(0,0,0,0.3);\n}\n\n.chat-mention-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.chat-mention-option:hover,\n.chat-mention-option.selected { background: var(--bg-active); color: var(--text-primary); }\n\n.chat-mention-option .role-dot {\n  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;\n}\n.role-dot-admin    { background: var(--red); }\n.role-dot-engineer { background: var(--accent-light); }\n.role-dot-foreman  { background: #4ec9b0; }\n.role-dot-standard { background: var(--text-muted); }\n.role-dot-client   { background: var(--yellow); }\n.role-dot-other    { background: var(--text-muted); opacity: 0.5; }\n\n/* ── Create Group Modal ───────────────────────────────────── */\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.5);\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 20px;\n  width: 360px;\n  max-width: 90vw;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.modal h3 { font-size: 14px; font-weight: 600; color: var(--text-primary); margin: 0; }\n\n.modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 4px; }\n\n.member-list {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  background: var(--bg-primary);\n}\n\n.member-list-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.member-list-item:hover { background: var(--bg-hover); color: var(--text-primary); }\n.member-list-item input[type=checkbox] { accent-color: var(--accent-light); }\n\n/* ── Inline message layout ────────────────────────────────── */\n.chat-message {\n  display: flex;\n  align-items: flex-start;\n  padding: 2px 16px;\n  gap: 0;\n  position: relative;\n  min-height: 22px;\n}\n.chat-message:hover { background: var(--bg-hover); }\n.chat-message-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  white-space: nowrap;\n  padding-right: 10px;\n  padding-top: 2px;\n  min-width: 0;\n}\n.chat-message-body {\n  flex: 1;\n  min-width: 0;\n  padding-top: 1px;\n}\n.chat-content {\n  font-size: 13px;\n  color: var(--text-primary);\n  line-height: 1.5;\n  word-break: break-word;\n  white-space: pre-wrap;\n  display: inline;\n}\n.chat-msg-actions {\n  display: flex;\n  flex-shrink: 0;\n  opacity: 0;\n  gap: 2px;\n  margin-top: 1px;\n  transition: opacity 0.1s;\n}\n.chat-message:hover .chat-msg-actions { opacity: 1; }\n\n.chat-delete-btn {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  background: none;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  transition: color 0.1s;\n}\n.chat-delete-btn:hover { color: var(--red); background: var(--bg-tertiary); }\n\n.chat-edited {\n  font-size: 10px;\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n.chat-edit-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 2px;\n}\n.chat-edit-input {\n  width: 100%;\n  min-height: 60px;\n  max-height: 200px;\n  resize: vertical;\n  background: var(--bg-input);\n  border: 1px solid var(--accent-light);\n  border-radius: 4px;\n  color: var(--text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  padding: 6px 8px;\n  line-height: 1.4;\n  white-space: pre-wrap;\n  outline: none;\n}\n.chat-edit-actions {\n  display: flex;\n  gap: 4px;\n}\n\n/* Always visible on touch screens */\n@media (hover: none) {\n  .chat-message .chat-msg-actions { opacity: 0.35; }\n}\n\n/* ── Member tooltip ───────────────────────────────────────── */\n.chat-members-hover {\n  position: relative;\n  cursor: default;\n  display: inline-block;\n}\n.chat-members-tooltip {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 6px 0;\n  min-width: 130px;\n  z-index: 50;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.4);\n}\n.chat-members-tooltip-item {\n  padding: 4px 12px;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* ── Online status dot ────────────────────────────────────── */\n.online-dot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--text-muted);\n  flex-shrink: 0;\n}\n.online-dot.online { background: #4ec9b0; }\n\n/* ── Typing indicator ─────────────────────────────────────── */\n.chat-typing {\n  padding: 3px 16px 3px;\n  font-size: 11px;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.chat-typing-dots {\n  display: flex;\n  gap: 3px;\n  align-items: center;\n}\n.chat-typing-dots span {\n  width: 5px; height: 5px;\n  background: var(--text-muted);\n  border-radius: 50%;\n  animation: typing-bounce 1.2s infinite;\n}\n.chat-typing-dots span:nth-child(2) { animation-delay: 0.2s; }\n.chat-typing-dots span:nth-child(3) { animation-delay: 0.4s; }\n@keyframes typing-bounce {\n  0%, 60%, 100% { transform: translateY(0); }\n  30%            { transform: translateY(-4px); }\n}\n\n/* ── Message search bar ───────────────────────────────────── */\n.chat-search-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-secondary);\n  flex-shrink: 0;\n}\n.chat-search-input {\n  flex: 1;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  color: var(--text-primary);\n  font-size: 12px;\n  padding: 3px 7px;\n  outline: none;\n}\n.chat-search-input:focus { border-color: var(--accent-light); }\n.chat-search-count { font-size: 11px; color: var(--text-muted); white-space: nowrap; }\n\n/* ── Mobile chat adjustments ─────────────────────────────── */\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .chat-input { font-size: 16px; min-height: 44px; }\n  .chat-send-btn { height: 44px; padding: 0 18px; font-size: 15px; }\n  .chat-attach-btn { width: 44px; height: 44px; }\n  .chat-sidebar-item { padding: 10px 10px 10px 14px; font-size: 14px; min-height: 44px; }\n  .chat-img { max-width: 100%; }\n  /* Push input area above the fixed bottom activity bar (56px) */\n  .chat-input-area { padding-bottom: calc(8px + 56px); }\n}\n\n/* ── Lightbox ─────────────────────────────────────────────── */\n.lightbox-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.85);\n  z-index: 300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: zoom-out;\n}\n.lightbox-img {\n  max-width: 90vw;\n  max-height: 90vh;\n  object-fit: contain;\n  border-radius: 4px;\n  cursor: default;\n  box-shadow: 0 8px 40px rgba(0,0,0,0.6);\n}\n.lightbox-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255,255,255,0.1);\n  border-radius: 50%;\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.lightbox-close:hover { background: rgba(255,255,255,0.2); }\n\n/* ── File attachments in messages ─────────────────────────── */\n.chat-file-attach {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--accent-light);\n  text-decoration: none;\n  cursor: pointer;\n  margin-top: 4px;\n}\n.chat-file-attach:hover { background: var(--bg-active); text-decoration: underline; }\n\n/* ── Pending file chips in input ──────────────────────────── */\n.chat-pending-files {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding-bottom: 6px;\n}\n.chat-file-pending {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 8px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  position: relative;\n}\n.chat-file-pending.uploading { opacity: 0.5; }\n.chat-file-pending-name { max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n/* ── Activity badge (used in ActivityBar) ─────────────────── */\n.activity-badge {\n  position: absolute;\n  top: 6px; right: 6px;\n  background: var(--red);\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  border-radius: 10px;\n  min-width: 14px;\n  height: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 3px;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
